import { FC } from 'react'
import { SocialMediaProps } from './interfaces'

const Pinterest: FC<SocialMediaProps> = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.white

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59781 0C4.36848 0 0.128906 4.2535 0.128906 9.5C0.128906 13.5244 2.62433 16.9655 6.14692 18.3495C6.06431 17.5981 5.9895 16.4416 6.17966 15.6214C6.35189 14.8802 7.29021 10.8996 7.29021 10.8996C7.29021 10.8996 7.00731 10.3304 7.00731 9.48905C7.00731 8.16844 7.77028 7.18169 8.72028 7.18169C9.52845 7.18169 9.91812 7.79 9.91812 8.51951C9.91812 9.33424 9.40064 10.5532 9.13411 11.6823C8.91122 12.6276 9.60639 13.3993 10.5361 13.3993C12.2195 13.3993 13.5124 11.6189 13.5124 9.04885C13.5124 6.77432 11.8836 5.18395 9.55729 5.18395C6.86313 5.18395 5.28186 7.2114 5.28186 9.30687C5.28186 10.1232 5.59515 10.9989 5.98638 11.4751C6.06353 11.5689 6.07522 11.6518 6.05184 11.7472C5.98015 12.0474 5.82038 12.6925 5.78921 12.8246C5.7479 12.9982 5.65205 13.0357 5.4728 12.9521C4.28977 12.4 3.55096 10.665 3.55096 9.27169C3.55096 6.27469 5.72141 3.52321 9.80745 3.52321C13.0923 3.52321 15.6447 5.87123 15.6447 9.00975C15.6447 12.2835 13.5872 14.9185 10.731 14.9185C9.7716 14.9185 8.86914 14.4181 8.56052 13.8278C8.56052 13.8278 8.08591 15.6418 7.97056 16.0859C7.75703 16.9108 7.17954 17.9452 6.79377 18.5762C7.67987 18.8514 8.62131 19 9.59703 19C14.8264 19 19.0659 14.7465 19.0659 9.5C19.0667 4.2535 14.8271 0 9.59781 0Z"
        fill={fillColor[color] || DEFAULT_COLOR}
      />
    </svg>
  )
}

export default Pinterest
